// Поиск по списку допродаж: терпит транслит («gazobeton») и набор не в той
// раскладке («ufpj,tnjy»). Вынесен из InsulationFriendsList без изменения логики,
// чтобы окно «Дополнить машину» фильтровало тот же список тем же способом,
// а не заводило второй поиск.

const transliterateMap = {
  'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh', 'з': 'z',
  'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r',
  'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'sch',
  'ь': '', 'ы': 'y', 'ъ': '', 'э': 'e', 'ю': 'yu', 'я': 'ya',
  'a': 'а', 'b': 'б', 'v': 'в', 'g': 'г', 'd': 'д', 'e': 'е', 'f': 'ф', 'h': 'х', 'i': 'и',
  'j': 'й', 'k': 'к', 'l': 'л', 'm': 'м', 'n': 'н', 'o': 'о', 'p': 'п', 'r': 'р', 's': 'с',
  't': 'т', 'u': 'у', 'w': 'в', 'x': 'кс', 'y': 'у', 'z': 'з'
};

const keyboardLayoutMap = {
  'q': 'й', 'w': 'ц', 'e': 'у', 'r': 'к', 't': 'е', 'y': 'н', 'u': 'г', 'i': 'ш', 'o': 'щ', 'p': 'з',
  'a': 'ф', 's': 'ы', 'd': 'в', 'f': 'а', 'g': 'п', 'h': 'р', 'j': 'о', 'k': 'л', 'l': 'д',
  'z': 'я', 'x': 'ч', 'c': 'с', 'v': 'м', 'b': 'и', 'n': 'т', 'm': 'ь',
  'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p',
  'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l',
  'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm'
};

const transliterate = (text) => {
  if (!text) return '';
  return String(text).toLowerCase().split('').map((char) => transliterateMap[char] || char).join('');
};

const convertKeyboardLayout = (text) => {
  if (!text) return '';
  return String(text).toLowerCase().split('').map((char) => keyboardLayoutMap[char] || char).join('');
};

export const createSearchVariants = (text) => {
  if (!text) return [];
  const original = String(text).toLowerCase();
  const transliterated = transliterate(text);
  const layoutConverted = convertKeyboardLayout(text);

  const variants = [original];

  if (transliterated !== original) {
    variants.push(transliterated);
  }

  if (layoutConverted !== original) {
    variants.push(layoutConverted);
    // Также добавляем транслитерацию от конвертированного текста
    const layoutTransliterated = transliterate(layoutConverted);
    if (layoutTransliterated !== layoutConverted && !variants.includes(layoutTransliterated)) {
      variants.push(layoutTransliterated);
    }
  }

  return variants;
};

/** Все слова запроса должны найтись (логика И) в наименовании или категории. */
export const filterUpsellItems = (items, searchQuery) => {
  const list = Array.isArray(items) ? items : [];
  if (!String(searchQuery || '').trim()) {
    return list;
  }

  const query = String(searchQuery).toLowerCase().trim();
  const keywords = query.split(/\s+/).filter((word) => word.length > 0);

  return list.filter((item) => {
    const productNameVariants = createSearchVariants(item.product_calculator_name);
    const categoryVariants = createSearchVariants(item.category);

    return keywords.every((keyword) => {
      const keywordVariants = createSearchVariants(keyword);

      return keywordVariants.some((keywordVar) =>
        productNameVariants.some((nameVar) => nameVar.includes(keywordVar)) ||
        categoryVariants.some((catVar) => catVar.includes(keywordVar))
      );
    });
  });
};

export default filterUpsellItems;
